import { c as _c } from "react/compiler-runtime";
import { Icon, Title } from "@justhome/react-ui";
import useLinks from "@lib/hooks/useLinks";
import MaximumBudgetCard from "@modules/application/components/MaximumBudgetCard";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useRouter } from "@lib/hooks/useRouter";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { CheckOne } from "@icon-park/svg";
const BudgetCheckResult = () => {
  const $ = _c(19);
  const {
    state: t0
  } = useApplicationContext();
  const {
    maximumBudget
  } = t0;
  const {
    t
  } = useTranslation("budget-check");
  const router = useRouter();
  const {
    getApplicationProcessLink
  } = useLinks();
  const {
    partner
  } = usePartnerContext();
  let t1;
  let t2;
  if ($[0] !== getApplicationProcessLink || $[1] !== maximumBudget || $[2] !== router) {
    t1 = () => {
      if (!maximumBudget) {
        router.push(getApplicationProcessLink("budget-check"));
      }
    };
    t2 = [maximumBudget, getApplicationProcessLink, router];
    $[0] = getApplicationProcessLink;
    $[1] = maximumBudget;
    $[2] = router;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!maximumBudget) {
    return null;
  }
  const hasSearchProfile = !!maximumBudget.searchProfile?.placeId;
  let t3;
  if ($[5] !== hasSearchProfile || $[6] !== partner || $[7] !== t) {
    t3 = hasSearchProfile && partner ? <div className="text-center mb-3s text-balance"><Icon icon={CheckOne} size="40" /><Title as="h1" className="text-h1">{t("result_title_search_profile", {
          partnerName: partner.name
        })}</Title></div> : <Title as="h1" className="text-center text-h1 mb-3s text-balance">{t("result_title")}</Title>;
    $[5] = hasSearchProfile;
    $[6] = partner;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const title = t3;
  let t4;
  if ($[9] !== maximumBudget) {
    t4 = <MaximumBudgetCard maximumBudget={maximumBudget} />;
    $[9] = maximumBudget;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("result_note");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <p className="my-3s text-body-2">{t5}</p>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== title) {
    t7 = <div className="mx-auto w-[772px] max-w-full grow flex flex-col items-center mb-3s m:mb-3m"><div className="flex flex-col">{title}{t4}{t6}</div></div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = title;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default BudgetCheckResult;